import React from "react";

type Props = {} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({ className, ...props }: Props) {
  return (
    <button className={`bullet-button ${className ?? ""}`} {...props}>
      {props.children}
    </button>
  );
}
